<template>
  <div
    :class="
      $vuetify.breakpoint.xsOnly
        ? 'px-0 py-2 animate__animated animate__fadeIn'
        : 'pa-4 animate__animated animate__fadeIn'
    "
  >
    <h2 class="title_tab mb-1">
      สาขา
      <v-btn
        :class="$vuetify.breakpoint.xsOnly ? 'float-right' : 'float-right mt-2'"
        color="button"
        dark
        small
        @click="openDialog"
      >
        <v-icon x-small class="mr-1">mdi-plus</v-icon>เพิ่มสาขา
      </v-btn>
    </h2>
    <!-- <pre>{{all_location_data}}</pre> -->
    <!-- <pre>{{env+'/'+all_location_data[0].image[0].image_path}}</pre>
    <v-img :src="env+'/'+all_location_data[0].image[0].image_path"></v-img>-->
    <div>
      <v-row class="pb-1 pt-0">
        <!-- <v-col :cols="$vuetify.breakpoint.xsOnly?0:6" sm="6" md="8"></v-col> -->
        <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" sm="6" md="6">
          <v-text-field
            label="ค้นหาชื่อสาขา"
            hide-details
            outlined
            prepend-inner-icon="mdi-magnify"
            clearable
            v-model="search"
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        :search="search"
        :headers="headers"
        :items="all_location_data"
        hide-default-header
        :items-per-page="max_per_page"
        class="data_table_footer"
        :page.sync="page"
        @page-count="pageCount = $event"
      >
        <template v-slot:top v-if="!$vuetify.breakpoint.xsOnly">
          <div class="pt-2" v-if="!$vuetify.breakpoint.xsOnly">
            <v-card
              flat
              :style="
                datatable_tablet
                  ? 'border-radius:10px ;font-size:13px;'
                  : 'border-radius:10px'
              "
              color="card_header"
              class="px-4 pl-6 location-header"
            >
              <v-row>
                <v-col
                  v-for="(item, index) in headers"
                  :key="index"
                  :cols="index == 0 ? 1 : index == 5 ? 3 : 2"
                  :sm="index == 0 ? 1 : index == 2 ? 3 : index == 4 ? 2 : 2"
                  :class="index == 0 ? 'px-1' : ''"
                  :style="
                    index == 0
                      ? 'max-width:5%'
                      : index == 3
                      ? 'margin-left:1%'
                      : index == 2
                      ? 'margin-left:0.25%'
                      : index == 4
                      ? 'margin-left:0.5%'
                      : ''
                  "
                  >{{ index == 4 ? "โทรศัพท์" : item.text }}</v-col
                >
              </v-row>
            </v-card>
          </div>
        </template>
        <!-- <template v-slot:no-data>
          <div class="text-center pa-12">
            <p
              class="py-6"
              :style="$vuetify.breakpoint.xsOnly?'font-size:16px;':'font-size:22px;'"
            >ไม่มีข้อมูล</p>
          </div>
        </template>-->
        <template v-slot:body="{ items }" v-if="all_location_data != ''">
          <div class="text-center pa-12" v-if="items == ''">
            <p
              class="py-6"
              :style="
                $vuetify.breakpoint.xsOnly
                  ? 'font-size:16px;'
                  : 'font-size:22px;'
              "
            >
              ไม่มีข้อมูล
            </p>
          </div>
          <div v-if="items != ''">
            <div v-if="!$vuetify.breakpoint.xsOnly">
              <v-card
                flat
                style="border-radius: 10px"
                color="card_body"
                v-for="(item, index) in items"
                :key="index"
                class="my-2 py-1 location-text"
              >
                <!-- {{env+'/'+item.image[0].image_path}} -->
                <v-row align="center" justify="center" class="font-kanit-bold">
                  <v-col cols="1" class="px-1 pl-2" style="max-width: 5%">{{
                    all_location_data.indexOf(item) + 1
                  }}</v-col>
                  <v-col cols="2">
                    <v-card
                      tile
                      class="text-center py-8"
                      v-if="item.image_path_by_id == ''"
                    >
                      <v-progress-circular
                        :width="3"
                        color="red"
                        indeterminate
                      ></v-progress-circular>
                    </v-card>

                    <v-img
                      v-if="item.image_path_by_id != ''"
                      :src="item.image_path_by_id"
                      aspect-ratio="1.6"
                    ></v-img>
                  </v-col>
                  <v-col cols="2" sm="3">{{ item.name }}</v-col>
                  <v-col cols="2" sm="2">{{ item.work_time }}</v-col>
                  <v-col cols="2" sm="2">{{ item.phone }}</v-col>
                  <v-col cols="3" sm="2">
                    <v-btn
                      @click="openDialog(item)"
                      class="float-right font-kanit-light"
                      outlined
                      :small="!$vuetify.breakpoint.smOnly"
                      :x-small="$vuetify.breakpoint.smOnly"
                      style="background: white"
                      >รายละเอียด</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <div class="pa-0" v-if="$vuetify.breakpoint.xsOnly">
              <v-card
                flat
                color="card_header"
                v-for="(item, index) in items"
                :key="index"
                class="my-2 px-4 py-0 pr-3"
              >
                <v-row align="center" justify="center" class="pa-0">
                  <v-col cols="12" class="py-0">
                    <v-row class="py-0">
                      <v-col cols="5" class="location-xs-header py-0 pt-2"
                        >ลำดับ</v-col
                      >
                      <v-col
                        cols="7"
                        style="background: #f2f2f2"
                        class="location-xs-text py-0 pt-2"
                        >{{ all_location_data.indexOf(item) + 1 }}</v-col
                      >
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-row class="py-0">
                      <v-col cols="5" class="location-xs-header py-0 pt-2"
                        >ชื่อสาขา</v-col
                      >
                      <v-col
                        cols="7"
                        style="background: #f2f2f2"
                        class="location-xs-text py-0 pt-2"
                        >{{ item.name }}</v-col
                      >
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-row class="py-0">
                      <v-col cols="5" class="location-xs-header py-0 pt-1"
                        >เวลาทำการ</v-col
                      >
                      <v-col
                        cols="7"
                        style="background: #f2f2f2"
                        class="location-xs-text py-0 pt-1"
                        >{{ item.work_time }}</v-col
                      >
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-row class="py-0">
                      <v-col cols="5" class="location-xs-header py-0 pt-1"
                        >หมายเลขโทรศัพท์</v-col
                      >
                      <v-col
                        cols="7"
                        style="background: #f2f2f2"
                        class="location-xs-text py-0 pt-1"
                        >{{ item.phone }}</v-col
                      >
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-row class="py-0">
                      <v-col
                        cols="5"
                        class="location-xs-header py-0 pt-1 pb-2"
                      ></v-col>
                      <v-col
                        cols="7"
                        style="background: #f2f2f2"
                        class="location-xs-text py-0 pt-1 pb-2"
                      >
                        <v-btn
                          @click="openDialog(item)"
                          class="font-kanit-bold my-1"
                          outlined
                          block
                          small
                          style="background: white"
                          >รายละเอียด</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
        </template>
        <!-- <template v-slot:footer.page-text class="table_footer"></template> -->
      </v-data-table>

      <!-- <v-row align="center" justify="center">
          
          <v-col cols="4" class="location-xs-header">
            <v-col cols="12" class="py-0 location-xs-header">ชื่อสาขา</v-col>
            <v-col cols="12" class="py-0 location-xs-header">เวลาทำการ</v-col>
            <v-col cols="12" class="py-0 location-xs-header">หมายเลขโทรศัพท์</v-col>
          </v-col>
          <v-col cols="8" class="location-xs-header">
            <v-col cols="12" class="py-0 location-xs-text">{{item.name}}</v-col>
            <v-col cols="12" class="py-0 location-xs-text">{{item.period}}</v-col>
            <v-col cols="12" class="py-0 location-xs-text">{{item.tel}}</v-col>
            <v-col cols="12" class="py-0 location-xs-text">
              <v-btn
                class="font-kanit-bold my-1"
                outlined
                block
                small
                style="background:white"
              >รายละเอียด</v-btn>
            </v-col>
          </v-col>
      </v-row>-->

      <!-- <div class="text-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" xs="12" sm="10" md="8" xl="8" lg="7">
            <v-container class="max-width">
              <v-pagination v-model="page" class="my-4" :length="length_page"></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      </div>-->
      <!-- <div class="text-center">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" xs="12" sm="10" md="8" xl="8" lg="7">
              <v-container class="max-width">
                <v-pagination v-model="page" :length="pageCount" class="my-4"></v-pagination>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>-->
    </div>
    <DialogLocation ref="dialog" @getlocation="getData()" />
  </div>
</template>
<script>
import DialogLocation from "../dialogsetting/DialogLocation";
export default {
  components: { DialogLocation },
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      env: process.env.VUE_APP_API,
      page: 1,
      pageCount: 0,
      length_page: 1,
      max_per_page: 10,
      search: "",
      headers: [
        {
          text: "#",
          sortable: false,
          value: "index",
        },
        {
          text: "ภาพสาขา",
          sortable: false,
          value: "images",
        },
        {
          text: "ชื่อสาขา",
          sortable: false,
          value: "name",
        },
        {
          text: "เวลาทำการ",
          sortable: false,
          value: "period",
        },
        {
          text: "หมายเลขโทรศัพท์",
          sortable: false,
          value: "tel",
        },
        {
          text: "",
          sortable: false,
          value: "action",
        },
      ],
      all_location_data: [],
      page_location: [],
    };
  },

  mounted() {},
  created() {
    // console.log(this.$store.state.nav_drawer);
    // document.getElementById("list-359").style.left = "850;";
    // document
    //   .getElementsByClassName("table-footer")
    document.getElementsByClassName("v-menu__content").style =
      "left:500px;!important";
    // console.log(
    //   document.getElementsByClassName(
    //     "v-menu__content theme--light menuable__content__active"
    //   )
    // );
    this.getData();
  },
  watch: {
    // page(value) {
    //   if (this.all_location_data.length != 0) {
    // this.page_location = [];
    // // console.log(value);
    // let data_location_show = [];
    // let location_length = this.all_location_data.length;
    // let check_over_data = location_length / this.max_per_page;
    // console.log(location_length);
    // check_over_data = parseInt(check_over_data);
    // console.log(check_over_data);
    // if (value == this.length_page) {
    //   for (
    //     let index = (value - 1) * this.max_per_page;
    //     index < location_length;
    //     index++
    //   ) {
    //     data_location_show.push(this.all_location_data[index]);
    //   }
    //   // console.log(data_location_show);
    //   this.page_location = data_location_show;
    // } else {
    //   for (
    //     let index = (value - 1) * this.max_per_page;
    //     index < value * this.max_per_page;
    //     index++
    //   ) {
    //     data_location_show.push(this.all_location_data[index]);
    //   }
    //   // console.log(data_location_show);
    //   this.page_location = data_location_show;
    // }
    //   }
    // },
  },
  computed: {
    datatable_tablet() {
      if (
        this.$vuetify.breakpoint.width < 874 &&
        this.$vuetify.breakpoint.width >= 768
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getData() {
      let location = [];
      // let location_data = [];
      this.all_location_data = [];
      this.axios
        .get(
          process.env.VUE_APP_API + "/api/v1/location_all",
          this.header_token
        )
        .then((response) => {
          // console.log(response);
          location = response.data.result;
          if (response.data.result && response.data.status == "OK") {
            location.forEach((element) => {
              element.image_path_by_id = "";
            });

            // let check_length = response.data.result.length;
            // this.length_page = check_length / this.max_per_page;
            // this.length_page = parseInt(this.length_page);

            // if (check_length % this.max_per_page != 0) {
            //   this.length_page += 1;
            // }
            // console.log(check_length);
            // let get_data_location_show = [];
            this.all_location_data = location;
            // let get_location_length = location.length;
            // if (location.length >= 10) {
            //   for (let index = 0; index < this.max_per_page; index++) {
            //     get_data_location_show.push(location[index]);
            //   }
            //   // console.log(get_data_location_show);
            //   this.page_location = get_data_location_show;
            // } else {
            //   for (let index = 0; index < get_location_length; index++) {
            //     get_data_location_show.push(location[index]);
            //   }
            //   // console.log(get_data_location_show);
            //   this.page_location = get_data_location_show;
            // }
            this.previewImage();
          }
        });
    },
    previewImage() {
      var url;
      // this.image_promotion = null;
      // console.log(id);
      this.all_location_data.forEach((element, index) => {
        this.axios({
          url:
            process.env.VUE_APP_API + "/api/v1/image/" + element.image.image_id,
          method: "GET",
          responseType: "blob", // important
          headers: { token: this.$session.get("token") },
        })
          .then((response) => {
            url = window.URL.createObjectURL(new Blob([response.data]));
            // image_path_by_id = url;
            // element.image_path_by_id = image_path_by_id;
            // promotion_data.push(element);
            this.all_location_data[index].image_path_by_id = url;
          })
          .catch((err) => {
            this.all_location_data[index].image_path_by_id =
              "ไม่สามารถโหลดรูปได้";
          });
      });

      // return url;
    },
    openDialog(item) {
      this.$refs.dialog.open(item);
    },
  },
};
</script>


